import api from "api";
import { useMutation } from "react-query";

export interface UkReferralData {
  referral_date: string;
  site: string;
  urgency: string;
  pathway_ids: string[];
  body_parts_referred: string[];
  invited_joint: string;
  raw_input_text?: string;
  patient: {
    name: string;
    date_of_birth: string;
    nhs_number: string;
    email?: string;
    telephone_numbers?: string[];
    address?: string;
  };
  gp?: {
    name?: string;
    address?: string;
  };
}

export interface Vars {
  uk_referral_data: UkReferralData;
  file?: File;
}

export interface CreateUkReferralResponse {
  medical_referral_id: number;
  invitation_id?: number;
  patient_id?: number;
  status: "created_and_invited" | "linked_to_existing";
}

const readFileAsBase64 = (file: File): Promise<string> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      const result = reader.result as string;
      const base64 = result.split(",")[1];
      resolve(base64);
    };
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
};

const usePostReferralPdf = () => {
  return useMutation<CreateUkReferralResponse, Error, Vars>(async ({ uk_referral_data, file }) => {
    const payload: Record<string, unknown> = { uk_referral_data };

    if (file) {
      payload.file_body = await readFileAsBase64(file);
      payload.file_name = file.name;
    }

    const response = await api.call("/uk_referral_override", {
      data: payload,
      method: "POST",
    });

    return response.json();
  });
};

export default usePostReferralPdf;
